import debug from 'debug';

import router from '@/router';
import Logger from '../../lib/logger';

import guarantorService from './guarantor.service';

const log = debug('store:guarantor');

export default {
  namespaced: true,
  state: {
    isLoading: true,
    loadingMessage: 'Carregando...',

    guarantorData: null,
    guarantorApplicationId: null,
    guaranteedTransaction: null,
    CCBUrl: null,
    nextPage: null,
  },
  actions: {
    setLoading({ commit }, { isLoading, loadingMessage }) {
      commit('isLoading', { isLoading, loadingMessage });
    },
    async getGuarantorApplication({ commit, dispatch }, { guarantorApplicationId }) {
      try {
        if (!guarantorApplicationId) {
          dispatch('auth/setToken', { token: null }, { root: true });
          commit('goToPage', 'not-found');
          return;
        }

        const { guarantorApplication } = await guarantorService.getGuarantorApplication({
          guarantorApplicationId,
        });

        if (!guarantorApplication.deskInfo) {
          dispatch('auth/setToken', { token: null }, { root: true });
          commit('goToPage', 'not-found');
          return;
        }

        commit('setGuarantorApplication', guarantorApplication);

        if (guarantorApplication.signedAt) {
          commit('nextRoute', 'guarantor-accepted');
          return;
        }

        const CCBUrl = guarantorService.getCCBUrl({
          checkoutOptionId: guarantorApplication.transaction.checkoutOptionId,
        });

        commit('setCCBUrl', CCBUrl);

        commit('nextRoute', 'guarantor-agreement');
      } catch (error) {
        if (error && error.response && error.response.status === 401) {
          dispatch('auth/setToken', { token: null }, { root: true });
          commit('goToPage', 'login');
        } else {
          Logger.error(error);
          throw new Error(error);
        }
      }
    },
    async signGuarantorApplication({ state, commit, dispatch }) {
      try {
        await guarantorService.signGuarantorApplication({
          guarantorApplicationId: state.guarantorApplicationId,
        });

        commit('nextRoute', 'guarantor-accepted');
      } catch (error) {
        if (error && error.response && error.response.status === 401) {
          dispatch('auth/setToken', { token: null }, { root: true });
          commit('goToPage', 'login');
        } else {
          Logger.error(error);
          throw new Error(error);
        }
      }
    },
  },
  mutations: {
    isLoading(state, { isLoading, loadingMessage = 'Carregando...' }) {
      state.isLoading = isLoading;
      state.loadingMessage = loadingMessage;
    },
    goToPage(_, page) {
      return router.replace({ name: page }).catch((err) => log('router error', err));
    },
    setGuarantorApplication(state, guarantorApplication) {
      state.guarantorApplicationId = guarantorApplication._id;
      state.guaranteedTransaction = guarantorApplication.transaction;
      state.guarantorData = guarantorApplication;
    },
    setCCBUrl(state, CCBUrl) {
      state.CCBUrl = CCBUrl;
    },
    nextRoute(state, nextRoute) {
      state.nextPage = nextRoute;
    },
  },
};
